import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "reactstrap";

import logo from "../../img/logo-roubaix-blanc.svg";
import LanguageContext from "./../../state/context/LanguageContext";

const Footer = () => (
  <LanguageContext.Consumer>
    {({ language, translation }) => (
      <footer 
        className="footer text-white bg-dark"
        role="contentinfo"
        aria-label="Pied de page - Informations et liens utiles"
      >
        <Container>
          <Row className="align-items-top justify-content-between">
            <Col md="5" lg="2">
              <address>
                <img 
                  className="mb-3" 
                  src={logo} 
                  alt="Logo de la Ville de Roubaix" 
                />
                <br />
                17, Grand' Place
                <br />
                CS 70737
                <br />
                59100 Roubaix Cedex 1<br />
              </address>
            </Col>
            <Col className="contact-access" md="7" lg="4">
              <nav id="footer-contacts" aria-label="Contacts et accès" tabIndex={-1}>
                <ul className="list-unstyled d-flex">
                <li className="w-100">
                  <a
                    href="/appeler-laccueil"
                    className="d-block text-center px-3 border-right"
                    aria-label={`${translation.call} - Appeler l'accueil`}
                  >
                    <i className="icon-phone d-block mb-3" aria-hidden="true" />
                    {translation.call}
                  </a>
                </li>
                <li className="w-100">
                  <Link
                    to="/contact"
                    className="d-block text-center px-3 border-right"
                    aria-label={`${translation.contact} - Page de contact`}
                  >
                    <i className="icon-markunread d-block mb-3" aria-hidden="true" />
                    {translation.contact}
                  </Link>
                </li>
                <li className="w-100">
                  <a
                    href="/signaler-un-probleme"
                    className="d-block text-center px-3"
                    aria-label={`${translation.problem} - Signaler un problème`}
                  >
                    <i className="icon-chat d-block mb-3" aria-hidden="true" />
                    {translation.problem}
                  </a>
                                  </li>
                </ul>
              </nav>
            </Col>
            <Col>
              <p className="footer-nl-title">{translation.newsletterlabel}</p>
              <Link
                to="/la-newsletter-de-roubaix/"
                rel="noopener noreferrer"
                className="footer-nl-link btn btn-lg btn-primary"
                aria-label={`${translation.subscribe} - S'abonner à la newsletter`}
              >
                {translation.subscribe}
              </Link>
            </Col>
          </Row>
        </Container>
        <div className="w-100 pt-3 pb-3 bg-black footer-alt">
          <Container>
            <nav aria-label="Liens légaux et accessibilité">
              <ul>
                <li>
                  <a
                    className="footer-alt-link"
                    href={translation.legalLink}
                    title={translation.legal}
                    aria-label={`${translation.legal} - Mentions légales`}
                  >
                    {translation.legal}
                  </a>
                </li>
                <li>
                  <a
                    className="footer-alt-link"
                    href="/professionnels/presse/"
                    title={translation.presse}
                    aria-label={`${translation.presse} - Espace presse`}
                  >
                    {translation.presse}
                  </a>
                </li>
                <li>
                  <a
                    className="footer-alt-link"
                    href="/accessibilite"
                    title={translation.footerAccessibility}
                    aria-label={`${translation.footerAccessibility} - Page d'accessibilité`}
                  >
                    {translation.footerAccessibility}
                  </a>
                </li>
                <li>
                  <a
                    className="footer-alt-link link-malentendant"
                    href="/contact-malentendant-sourd"
                    title={translation.footerMalentendant}
                    aria-label={`${translation.footerMalentendant} - Contact pour malentendants et sourds`}
                  >
                    {translation.footerMalentendant}
                  </a>
                </li>
              </ul>
            </nav>
          </Container>
        </div>
      </footer>
    )}
  </LanguageContext.Consumer>
);

export default Footer;
